import { Component, ViewChild } from '@angular/core';
import { NavController, Slides } from 'ionic-angular';
import { RegisterPage } from '../register/register';
import { LoginPage } from '../login/login';
import { Storage } from '@ionic/storage';
import { HomePage } from "../home/home";

@Component({
  selector: 'page-introduction',
  templateUrl: 'introduction.html'
})
export class IntroductionPage {

	@ViewChild('slides') public slides: Slides;

    public currentSlide: number = null;
    public isDragging: boolean = false;

	constructor(public navCtrl: NavController, private storage: Storage) {

    }

    public ngAfterViewInit() {
        this.slides.speed = 200;
        this.slides.ionSlideReachStart.subscribe(() => this.onSlideChange());
        this.slides.ionSlideTouchEnd.subscribe(() => this.isDragging = false);
        this.slides.ionSlideTouchStart.subscribe(() => this.isDragging = true);
        this.slides.ionSlideWillChange.subscribe(() => this.onSlideChange());
        this.slides.ionSlideProgress.subscribe(() => {
            let total = this.slides.length() - 1;
            let slide = total * this.slides.progress;

            let left = Math.floor(slide);
            let right = left + 1;

            if (left < 0) left = 0;
            if (right > total) right = total;

        });
    }

	/**
	 * goToRegister
	 */
	public goToRegister() {
	    this.clearFirstRun();

        this.navCtrl.setRoot(RegisterPage, null, {
            animate: true,
            direction: 'forward'
        });
	}

	/**
	 * goToLogin
	 */
	public goToLogin() {
        this.clearFirstRun();

        this.navCtrl.setRoot(LoginPage, null, {
            animate: true,
            direction: 'forward'
        });
	}

	public onSlideChange() {
		let currentSlide = this.slides._slides ? this.slides._activeIndex : 0;
		if (isNaN(currentSlide)) currentSlide = 0;

		let totalSlides = this.slides._slides ? this.slides._slides.length : 0;

		if (currentSlide < 0) currentSlide = 0;
		if ((currentSlide + 1) > totalSlides) currentSlide = totalSlides - 1;

		this.currentSlide = currentSlide;
	}

    public skip() {
        this.clearFirstRun();
        this.slides.slideTo(this.slides.length() - 1);
    }

    public goNext() {
        this.slides.slideNext();
    }

    public isFirstSlide() {
        return this.slides.isBeginning();
    }

    public isLastSlide() {
        return this.slides.isEnd();
    }

    private clearFirstRun() {
        return this.storage.set('firstRun', false);
    }

}



// WEBPACK FOOTER //
// ./src/pages/introduction/introduction.ts